export default function padSAtTheEndIfPlural(value: number | string, string: string): string { 
  return `${string}${Number(value) > 1 ? 's' : ''}`;
}


// WEBPACK FOOTER //
// ./src/lib/helpers/padSAtTheEndIfPlural.js